// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalOptionsPageV2MetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GlobalOptionsPageV2MetadataQuery = { __typename?: 'Query', globalOptionTypes: Array<{ __typename?: 'GlobalOptionType', version: number, id: string, name: string }> };

export type GlobalOptionsPageV2QueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalOptionsFilter>;
}>;


export type GlobalOptionsPageV2Query = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', code: string, activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> }> };

export type SaveGlobalOptionsPageV2MutationVariables = Types.Exact<{
  globalOptions: Array<Types.SaveGlobalOptionInput> | Types.SaveGlobalOptionInput;
}>;


export type SaveGlobalOptionsPageV2Mutation = { __typename?: 'Mutation', saveGlobalOptions: { __typename?: 'SaveGlobalOptionsResult', globalOptions: Array<{ __typename?: 'GlobalOption', code: string, activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> }> } };

export type GlobalOptionsPageV2_GlobalOptionFragment = { __typename?: 'GlobalOption', code: string, activeDate?: Types.Scalars['Date']['input'] | null | undefined, archivedDate?: Types.Scalars['Date']['input'] | null | undefined, id: string, name: string, type: { __typename?: 'GlobalOptionType', version: number, id: string, name: string }, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, isSingleOptionGroup: boolean }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, statusDetail: { __typename?: 'GlobalOptionStatusDetail', code: Types.GlobalOptionStatus, name: string }, tags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }>, supportedTags: Array<{ __typename?: 'GlobalOptionTag', id: string, name: string }> };

export const GlobalOptionsPageV2_GlobalOptionFragmentDoc = gql`
    fragment GlobalOptionsPageV2_GlobalOption on GlobalOption {
  ...Named
  code
  type {
    ...Named
    version
  }
  group {
    id
    name
    isSingleOptionGroup
  }
  locations {
    id
    name
  }
  statusDetail {
    code
    name
  }
  activeDate
  archivedDate
  tags {
    ...Named
  }
  supportedTags {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const GlobalOptionsPageV2MetadataDocument = gql`
    query GlobalOptionsPageV2Metadata {
  globalOptionTypes(filter: {version: [2], isCatalogV2: true}) {
    ...Named
    version
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useGlobalOptionsPageV2MetadataQuery__
 *
 * To run a query within a React component, call `useGlobalOptionsPageV2MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsPageV2MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsPageV2MetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalOptionsPageV2MetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>(GlobalOptionsPageV2MetadataDocument, options);
      }
export function useGlobalOptionsPageV2MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>(GlobalOptionsPageV2MetadataDocument, options);
        }
// @ts-ignore
export function useGlobalOptionsPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>;
export function useGlobalOptionsPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageV2MetadataQuery | undefined, GlobalOptionsPageV2MetadataQueryVariables>;
export function useGlobalOptionsPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>(GlobalOptionsPageV2MetadataDocument, options);
        }
export type GlobalOptionsPageV2MetadataQueryHookResult = ReturnType<typeof useGlobalOptionsPageV2MetadataQuery>;
export type GlobalOptionsPageV2MetadataLazyQueryHookResult = ReturnType<typeof useGlobalOptionsPageV2MetadataLazyQuery>;
export type GlobalOptionsPageV2MetadataSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsPageV2MetadataSuspenseQuery>;
export type GlobalOptionsPageV2MetadataQueryResult = Apollo.QueryResult<GlobalOptionsPageV2MetadataQuery, GlobalOptionsPageV2MetadataQueryVariables>;
export const GlobalOptionsPageV2Document = gql`
    query GlobalOptionsPageV2($filter: GlobalOptionsFilter) {
  globalOptions(filter: $filter) {
    ...GlobalOptionsPageV2_GlobalOption
  }
}
    ${GlobalOptionsPageV2_GlobalOptionFragmentDoc}`;

/**
 * __useGlobalOptionsPageV2Query__
 *
 * To run a query within a React component, call `useGlobalOptionsPageV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsPageV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsPageV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGlobalOptionsPageV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>(GlobalOptionsPageV2Document, options);
      }
export function useGlobalOptionsPageV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>(GlobalOptionsPageV2Document, options);
        }
// @ts-ignore
export function useGlobalOptionsPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>;
export function useGlobalOptionsPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalOptionsPageV2Query | undefined, GlobalOptionsPageV2QueryVariables>;
export function useGlobalOptionsPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>(GlobalOptionsPageV2Document, options);
        }
export type GlobalOptionsPageV2QueryHookResult = ReturnType<typeof useGlobalOptionsPageV2Query>;
export type GlobalOptionsPageV2LazyQueryHookResult = ReturnType<typeof useGlobalOptionsPageV2LazyQuery>;
export type GlobalOptionsPageV2SuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsPageV2SuspenseQuery>;
export type GlobalOptionsPageV2QueryResult = Apollo.QueryResult<GlobalOptionsPageV2Query, GlobalOptionsPageV2QueryVariables>;
export const SaveGlobalOptionsPageV2Document = gql`
    mutation SaveGlobalOptionsPageV2($globalOptions: [SaveGlobalOptionInput!]!) {
  saveGlobalOptions(input: {globalOptions: $globalOptions}) {
    globalOptions {
      ...GlobalOptionsPageV2_GlobalOption
    }
  }
}
    ${GlobalOptionsPageV2_GlobalOptionFragmentDoc}`;
export type SaveGlobalOptionsPageV2MutationFn = Apollo.MutationFunction<SaveGlobalOptionsPageV2Mutation, SaveGlobalOptionsPageV2MutationVariables>;

/**
 * __useSaveGlobalOptionsPageV2Mutation__
 *
 * To run a mutation, you first call `useSaveGlobalOptionsPageV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobalOptionsPageV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobalOptionsPageV2Mutation, { data, loading, error }] = useSaveGlobalOptionsPageV2Mutation({
 *   variables: {
 *      globalOptions: // value for 'globalOptions'
 *   },
 * });
 */
export function useSaveGlobalOptionsPageV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveGlobalOptionsPageV2Mutation, SaveGlobalOptionsPageV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveGlobalOptionsPageV2Mutation, SaveGlobalOptionsPageV2MutationVariables>(SaveGlobalOptionsPageV2Document, options);
      }
export type SaveGlobalOptionsPageV2MutationHookResult = ReturnType<typeof useSaveGlobalOptionsPageV2Mutation>;
export type SaveGlobalOptionsPageV2MutationResult = Apollo.MutationResult<SaveGlobalOptionsPageV2Mutation>;
export type SaveGlobalOptionsPageV2MutationOptions = Apollo.BaseMutationOptions<SaveGlobalOptionsPageV2Mutation, SaveGlobalOptionsPageV2MutationVariables>;